import { MaterialModule } from './../../material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ConfirmationDeleteComponent } from './confirmation-delete/confirmation-delete.component';
import { MediaConfirmationDeleteComponent } from './media-confirmation-delete/media-confirmation-delete.component';
import { ComplaintConfirmationDeleteComponent } from './complaint-confirmation-delete/complaint-confirmation-delete.component';
import { SeeAllCommentsComponent } from './see-all-comments/see-all-comments.component';
import { BusLinesComplaintsComponent } from './bus-lines-complaints/bus-lines-complaints.component';
import { ModalHistoryStatusComponent } from '../../pages/ocorrences/modal-history-status/modal-history-status.component';
import { EmergencyMeaningComponent } from './emergency-meaning/emergency-meaning.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		ImageModalComponent,
		ModalHistoryStatusComponent,
		ConfirmationDeleteComponent,
		MediaConfirmationDeleteComponent,
		ComplaintConfirmationDeleteComponent,
		SeeAllCommentsComponent,
		BusLinesComplaintsComponent,
		EmergencyMeaningComponent,
		NotificationsComponent,
	],
	imports: [CommonModule, MaterialModule, MatStepperModule, TranslateModule],
	exports: [ImageModalComponent, ModalHistoryStatusComponent],
})
export class ModalsModule {}
